/**
 * Цель события — текстовое поле, в которое сейчас печатают.
 *
 * Общая для всех экранов с горячими клавишами: копия этой проверки в каждом
 * из них разъезжается, и достаточно один раз забыть про contentEditable,
 * чтобы цифра из вердикта попала в текст вместо оценки.
 *
 * Слайдеры, чекбоксы и радио фокусируются после клика, но текст в них не
 * печатают — глотать клавиши должны только настоящие текстовые поля.
 */
export function isTypingTarget(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null
  if (!el) return false
  if (el.tagName === 'TEXTAREA' || el.isContentEditable) return true
  if (el.tagName !== 'INPUT') return false

  const type = (el as HTMLInputElement).type

  return !['range', 'checkbox', 'radio', 'button'].includes(type)
}
